module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-29.4-15d019c414d460c4c4228f6402eea0f2.svg";